import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { CYAN, YELLOW, GREEN } from '../../HOME/const';
import * as f from '../logic';

class Scoreboard extends Component {
  render() {
    const { stats, mode, size, board, togo } = this.props;
    const msecs = board.current ? board.current.state.msecs : 0;
    const { plays, aveScore, bestScore, grade, score } = f.getMoreStats(stats, size, mode, msecs);

    return (
      <div className="tt-scoreboard">
        <span style={{ gridArea: '1/1', color: YELLOW }}>{plays || 0}</span>
        <span style={{ gridArea: '2/1', marginTop: '-1px' }}>plays</span>
        <span style={{ gridArea: '1/2', color: GREEN }}>{aveScore || 0}</span>
        <span style={{ gridArea: '2/2', marginTop: '-1px' }}>ave. score</span>
        <span style={{ gridArea: '1/3', color: GREEN }}>{bestScore || 0}</span>
        <span style={{ gridArea: '2/3', marginTop: '-1px' }}>best score</span>
        <span className="tt-quartz" style={{ gridArea: '3/1', color: YELLOW }}>
          {grade}
        </span>
        <span className="tt-score-label" style={{ gridArea: '4/1' }}>
          grade
        </span>
        <span className="tt-quartz" style={{ color: CYAN }}>
          {togo || 0}
        </span>
        <span className="tt-score-label" style={{ gridArea: '4/2' }}>
          to go
        </span>
        <span className="tt-quartz" style={{ gridArea: '3/3', color: GREEN }}>
          {score}
        </span>
        <span className="tt-score-label" style={{ gridArea: '4/3' }}>
          score
        </span>
      </div>
    );
  }
}

function mapStateToProps({ mt, common }) {
  return { ...mt, ...common };
}

export default connect(
  mapStateToProps,
  {},
  null,
  { forwardRef: true }
)(Scoreboard);
